// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AccountMenuButton-cls1___b58aeccca8a5a45dd1e{/*!*/}.AccountMenuButton-cls2___b1ec5438486a6b41e89{margin-left:6px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AccountMenuButton-cls1___b58aeccca8a5a45dd1e",
	"cls2": "AccountMenuButton-cls2___b1ec5438486a6b41e89 AccountMenuButton-cls1___b58aeccca8a5a45dd1e"
};
export default ___CSS_LOADER_EXPORT___;
